var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClockOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 8.8C14.2626 8.8 8.8 14.2595 8.8 21C8.8 21.4398 8.44128 21.8 8 21.8C7.55872 21.8 7.2 21.4398 7.2 21C7.2 13.3804 13.3785 7.2 21 7.2C28.6215 7.2 34.8 13.3804 34.8 21C34.8 28.6196 28.6215 34.8 21 34.8C20.5587 34.8 20.2 34.4398 20.2 34C20.2 33.5602 20.5587 33.2 21 33.2C27.7374 33.2 33.2 27.7405 33.2 21C33.2 14.2595 27.7374 8.8 21 8.8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.128 22.6837L21.1999 22.6237V22.53V14C21.1999 13.5602 21.5586 13.2 21.9999 13.2C22.4412 13.2 22.7999 13.5602 22.7999 14V23C22.7999 23.2406 22.6943 23.4644 22.5119 23.6164L16.5126 28.6158C16.5125 28.6159 16.5124 28.616 16.5122 28.6161C16.1735 28.8954 15.6678 28.8478 15.385 28.5113L15.3848 28.5111C15.1039 28.1778 15.1471 27.6737 15.4887 27.383C15.4889 27.3828 15.4891 27.3826 15.4893 27.3824L21.128 22.6837Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockOutlined);
export default __webpack_public_path__ + "static/media/icon-clock-outlined.140240e17005460e923dcaed65cab36d.svg";
export { ForwardRef as ReactComponent };